module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.config && _vm.config.title) ? _c('div', {
    staticClass: "component-title-box"
  }, [_c('div', {
    staticClass: "title-box-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.t(_vm.config.title)))]), _vm._v(" "), (_vm.config.description) ? _c('span', {
    directives: [{
      name: "popover",
      rawName: "v-popover:tooltip",
      value: (_vm.t(_vm.config.description)),
      expression: "t(config.description)",
      arg: "tooltip"
    }],
    staticClass: "icon icon-help help-icon"
  }) : _vm._e()]), _vm._v(" "), _c('hr', {
    staticClass: "line"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ac8b5ac6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ComponentTitle.vue
// module id = 1343
// module chunks = 2